import { Component, OnInit, HostListener } from '@angular/core';
import { ShowHiddenService } from '../service/apiservice/showhidden.service';
import { Router } from '@angular/router';
import { Approved } from '../service/modal/approved';
import { ApprovedService } from '../service/apiservice/approved.service';
import { AuthenticationService } from '../authenticate/authentication.service';
import { LoginService } from '../service/apiservice/login.service';
import { Globals } from '../globals';
import { User } from '../service/modal/user';


declare var $;
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})

export class SidenavComponent implements OnInit {

  tabList: any;
  selected: any;
  selectedPath: any;
  genratedOtp;
  otpCheck;
  otpPresent: boolean;
  otpPresentEmergencyContactNo:boolean;
  passwordPresent: boolean;
  passwordCheck;
  eyeIcon: string = "zmdi-eye-off";
  hiddenGrid:Approved[] = new Array();
  approvedGrid:Approved[] = new Array();
  userInfo=new User();
  constructor(private global:Globals,private loginService:LoginService ,private _hiddenService: ShowHiddenService,private _approvedService:ApprovedService ,private router: Router,private authenticate:AuthenticationService) { }

  ngOnInit() {
    this.loadScript();
    this.passwordPresent = true;
    this.otpPresent = false;
    this.selected = 'Pending Request';
    this.tabList = [
      { path: 'pendingrequest', content: 'Pending Request' },
      { path: 'approvedhc', content: 'Approved HealthCard' },
      { path: 'staredhc', content: 'Starred HealthCard' },
      { path: 'blankpage', content: 'Show Hidden' },
      { path: 'sentemail', content: 'Sent HealthCard' },
      { path: 'trashhc', content: 'Trash HealthCard' },
      { path: 'specification', content: 'Specification' },
      { path: 'remark', content: 'Remark' },
      { path: 'subject', content: 'Subject' },
      { path: 'blankpage', content: 'All Approved HealthC' },
      { path: '', content: '' }
    ];
  }
  // { path: 'vital', content: 'Vital' },
  // public loadScript() {
  //   let body = <HTMLDivElement>document.body;
  //   let script = document.createElement('script');
  //   script.innerHTML = '';
  //   script.src = 'assets/js/app-script.js';
  //   script.async = true;
  //   script.defer = true;
  //   body.appendChild(script);
  // }

  public loadScript() {
 
      let body = <HTMLDivElement>document.body;
      let script = document.createElement('script');
      script.innerHTML = '';
      script.src = 'assets/js/app-script.js';
      script.async = true;
      script.defer = true;
      body.appendChild(script);
    
  }




  select(item, path) {
    debugger;
    this.selectedPath = path;
    this.selected = item;
    $("#searchBox").val("");
    if (window.innerWidth <= 600) {
      $("#wrapper").toggleClass("toggled");
    }
    if (item === "Show Hidden") {
      $("#transcationpassword").focus();
      this.passwordPresent = true;
      this.otpPresent = false;
      this.otpPresentEmergencyContactNo=false;
      $("#radioBtnPassword").prop("checked", true);

      this._hiddenService.GetHiddenList()
      .subscribe((response) => {
        Object.assign(this.hiddenGrid, response);
        console.log(this.hiddenGrid);
        if(this.hiddenGrid.length==0){
          this.router.navigate(['dashboard/showhidden']);
         }else{

          this.loginService.getUserById(this.global.loggedUser.user.user_reg_id).subscribe(response=>{
          this.userInfo=response;

          $(document).ready(function () {
            $("#otpshowmodal").modal({ backdrop: "static", keyboard: false });
  
          });
          },err=>{});
    }
      });

     this.hiddenGrid=new Array();       
      // this.generateOtp();
    }else if (item === "All Approved HealthC") {
      $("#transcationpassword").focus();
      this.passwordPresent = true;
      this.otpPresent = false;
      this.otpPresentEmergencyContactNo=false;
      $("#radioBtnPassword").prop("checked", true);
      this._approvedService.GetAllApprovedList()
      .subscribe((response) => {
        Object.assign(this.approvedGrid, response);
        if(this.approvedGrid.length==0){
          this.router.navigate(['dashboard/getotpallapproved']);
         }else{
          this.loginService.getUserById(this.global.loggedUser.user.user_reg_id).subscribe(response=>{
            this.userInfo=response;
  
            $(document).ready(function () {
              $("#otpshowmodal").modal({ backdrop: "static", keyboard: false });
            });
            },err=>{});
    }
    this.approvedGrid= new Array();
  });
    
    }else{
      console.log('dashboard/'+this.selectedPath);
      this.router.navigate(['dashboard/'+this.selectedPath]);
    }
  };
  isActive(item) {
    return item;
  };

  addTransctionPassword() {
    $('#otpshowmodal').modal('hide');
    this.router.navigate(['dashboard/transctionPassword']);
  }


  otpShowHidden(opt) {
    this._hiddenService.CheckOtp(this.genratedOtp, opt).subscribe((res) => {
      this.otpCheck = res;
      if (this.otpCheck == 'Match') {
         $("#otp").val('');
         $('#otpshowmodal').modal('hide');
         if (this.selected === 'Show Hidden') {
           this.router.navigate(['dashboard/showhidden']);
         }
         if (this.selected === 'All Approved HealthC') {
           this.router.navigate(['dashboard/getotpallapproved']);
         }
      } else {
        info_noti("Invaild Otp");
      }
    }, error => {

    });
  }
  checkTransctionalPassword(password) {
    this._hiddenService.CheckTransctionPassword(password).subscribe((res) => {
      this.passwordCheck = res;
      if (this.passwordCheck == 'Transcational Password Not Match') {
         info_noti("Transactional Password Not Match");
      } else {
        $("#transcationpassword").val('');
        $('#otpshowmodal').modal('hide');
        if (this.selected === 'Show Hidden') {
          this.router.navigate(['dashboard/showhidden']);
        }
        if (this.selected === 'All Approved HealthC') {
          this.router.navigate(['dashboard/getotpallapproved']);
        }
      }
    }, error => {

    });
  }
  cleardata() {
    $("#transcationpassword").val('');
    $("#otp").val('');
    $("#otpEmergencyContact").val('');

  }
  passwordShow() {
    this.eyeIcon = this.eyeIcon == "zmdi-eye" ? "zmdi-eye-off" : "zmdi-eye";
    if (this.eyeIcon == 'zmdi-eye-off') {
      $('#transcationpassword').attr('type', 'password');

    } else {
      $('#transcationpassword').attr('type', 'text');
    }
  }
  radiobuttonChecked(event) {
    console.log(event.target.otp);
    if (event.target.value == 'otp') {
      this._hiddenService.GenerateOtp('primaryMobileNo').subscribe((response) => {
        this.genratedOtp = response.otp_id;
      }, error => {

      });
      this.otpPresent = true;
      this.passwordPresent = false;
      this.otpPresentEmergencyContactNo=false;
    }
    if(event.target.value=='otpEmergencyContactNo'){
      this._hiddenService.GenerateOtp('EmergencyConatctNo').subscribe((response) => {
        if (response.message === 'Emergency Contact No Not Present') {
          alert("Emergency Contact Number Not Added  Please Login With Otp")
        } else {
          this.genratedOtp = response.otp_id;
        }

      }, error => {

      });
      this.otpPresent = false;
      this.passwordPresent = false;
      this.otpPresentEmergencyContactNo=true;
    }
    

    if (event.target.value == 'password') {
      this.passwordPresent = true;
      this.otpPresent = false;
      this.otpPresentEmergencyContactNo=false;
    }
  }


  // generateOtp() {
  //   this._hiddenService.GenerateOtp('EmergencyConatctNo').subscribe((response) => {
  //     console.log(response);
  //     this.genratedOtp = response.otp_id;
  //   });
  // }
  resendOtp(status) {
    this._hiddenService.GenerateOtp(status).subscribe((response) => {
      console.log(response);
      this.genratedOtp = response.otp_id;
    });
  }


  privacyPasswordOtpEnter(otp){
    $('#otpWithPrivacyPassword').focus();

    this.otpShowHidden(otp);
  }
  privacyPasswordOtpEnterEmergencyContact(otp){
    this.otpShowHidden(otp);
  }
  

  privacyPasswordPasswordEnter(password){
    $('#passwordWithPrivacyPassword').focus();
    
    this.checkTransctionalPassword(password);
  }
//browser back button or mobile back button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    console.log('Back button pressed');

    $("#otpshowmodal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();
  }

}
